import { render } from "./KSTable.vue?vue&type=template&id=06801572&scoped=true"
import script from "./KSTable.vue?vue&type=script&lang=js"
export * from "./KSTable.vue?vue&type=script&lang=js"

import "./KSTable.vue?vue&type=style&index=0&id=06801572&lang=css"
import "./KSTable.vue?vue&type=style&index=1&id=06801572&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06801572"]])

export default __exports__